export function defineVuepalAdapter(cb) {
  return cb();
}
